import {OutletBlogPostService} from "./service/api/outlet-blog-post.service";
import {OutletService} from "./service/api/outlet.service";
import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";
import {OutletContentService} from "./service/api/outlet-content.service";
import {OutletContentTypeService} from "./service/api/outlet-content-type.service";
import {
    OlOutletContentTypeObjectComponent
} from "./component/object-components/ol-outlet-content-type-object-component/ol-outlet-content-type-object.component";

export const OL_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['ol.OutletBlogPost', {route: '/ol/outletBlogPosts', service: OutletBlogPostService}],
            ['ol.OutletTheme', {route: '/ol/outletThemes'}],
            ['ol.Outlet', {route: '/ol/outlet', service: OutletService}],
            ['ol.OutletThemeColor', {route: '/ol/outletThemeColors'}],
            ['ol.OutletBlogGhostWriter', {route: '/ol/outletBlogGhostWriters'}],
            ['ol.OutletType', {route: '/ol/outletTypes'}],
            ['ol.OutletContent', {route: '/ol/outletContents', service: OutletContentService}],
            ['ol.OutletContentField', {route: '/ol/outletContentFields'}],
            ['ol.OutletContentType', {
                route: '/ol/outletContentTypes',
                service: OutletContentTypeService,
                objectComponent: [{component: OlOutletContentTypeObjectComponent}],
            }],
            ['ol.OutletContentTypeField', {route: '/ol/outletContentTypeFields'}],
            ['ol.OutletPromotion', {route: '/ol/outletPromotions'}],
            ['ol.OutletVisit', {route: '/ol/outletVisits'}],
        ] as EntityServiceEntry[],
        multi: true
    }
];
